<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_UserSecurityPolicy')"
    width="700px"
    :close-on-click-modal="false"
  >
    <el-form label-width="130px" label-position="right">
      <el-form-item :label="$t('CargoMsg.Cargo_PolicySettings')">
        <el-checkbox v-model="form.policyEnabled" no="policyEnabled">{{
          $t('CargoMsg.Cargo_EnableUserSecurityPolicy')
        }}
        </el-checkbox>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_PasswordLengthRange')">
        <div style="display: flex">
          <auto-number-input v-model="form.minPasswordLength" :enforce-min="true" :min="8" :max="20" style="width: 100px;padding-right: 10px" @change="lengthChange" /> -
          <auto-number-input v-model="form.maxPasswordLength" :enforce-min="true" :min="8" :max="20" style="width: 100px;padding-left: 10px;padding-right: 10px" @change="lengthChange" />
          {{ $t('CargoMsg.Cargo_MaxLengthRange8to20') }}
        </div>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_CompositionRule')">
        <div>
          <el-checkbox v-model="form.requireDigit" disabled no="requireDigit">{{
            $t('CargoMsg.Cargo_RequireNumUpperLower')
          }}
          </el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="form.requireSpecialChar" no="requireSpecialChar">{{
            $t('CargoMsg.Cargo_MustIncludeSpecialChars')
          }}
          </el-checkbox>
        </div>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_PasswordHistoryCheck')">
        <div style="display:flex;">
          <auto-number-input v-model="form.passwordRepeatCheck" :enforce-min="true" :min="0" :max="10" style="width: 100px;padding-right: 10px" /> {{ $t('CargoMsg.Cargo_HistoryLength0to10') }}
        </div>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_PasswordErrorLock')">
        <div style="display:flex;">
          <auto-number-input v-model="form.passwordErrorLock" :enforce-min="true" :min="0" :max="10" style="width: 100px;padding-right: 10px" /> {{ $t('CargoMsg.Cargo_LockLength0to10') }}
        </div>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_AdminApplication')">
        <el-checkbox v-model="form.applyToAdmin" no="applyToAdmin">{{
          $t('CargoMsg.Cargo_AdminPwdFollowPolicy')
        }}
        </el-checkbox>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="confirmHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button @click="innerVisible = false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import { queryUserSecurityPolicyFunc, saveUserSecurityPolicyFunc } from '@/api/userSecurityPolicy'

export default {
  name: 'UserSecurityPolicyDialog',
  components: { AutoNumberInput },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      form: {
        uuid: '',
        version: 1,
        tenantId: 0,
        policyEnabled: false,
        minPasswordLength: 8,
        maxPasswordLength: 20,
        requireDigit: true,
        requireSpecialChar: 0,
        passwordRepeatCheck: 0,
        passwordErrorLock: 0,
        applyToAdmin: 0
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.initData()
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    initData() {
      this.clearFrom()
      queryUserSecurityPolicyFunc().then(res => {
        if (res.data) {
          this.form = res.data
        }
      })
    },
    clearFrom() {
      this.form.uuid = ''
      this.form.version = 1
      this.form.tenantId = 0
      this.form.policyEnabled = false
      this.form.minPasswordLength = 8
      this.form.maxPasswordLength = 20
      this.form.requireDigit = true
      this.form.requireSpecialChar = 0
      this.form.passwordRepeatCheck = 0
      this.form.passwordErrorLock = 0
      this.form.applyToAdmin = 0
    },
    lengthChange() {
      if (Number(this.form.minPasswordLength) > Number(this.form.maxPasswordLength)) {
        this.form.minPasswordLength = '' // 先清空
        this.$nextTick(() => {
          this.form.minPasswordLength = 8 // 再赋值
        })
      }
    },
    async confirmHandler() {
      saveUserSecurityPolicyFunc(this.form).then(res => {
        this.innerVisible = false
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
